import { render, staticRenderFns } from "./BoardForm.vue?vue&type=template&id=525efbea&"
import script from "./BoardForm.vue?vue&type=script&lang=js&"
export * from "./BoardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports